import { useSetAtom, useAtomValue } from "jotai";
import {
  adjustmentTypesAtom,
  accountingSystemsAtom,
  adjustmentCategoriesAtom,
  deductionTypeCategoriesAtom,
  brandMembersAtom,
  deductionTypesAtom,
  distributionCentersAtom,
  documentSubTypesAtom,
  documentTypesAtom,
  getAdjustmentTypesAtom,
  getAccountingSystemsAtom,
  getAdjustmentCategoriesAtom,
  getDeductionTypeCategoriesAtom,
  getBrandMembersAtom,
  getDocumentSubTypesAtom,
  getDeductionTypesAtom,
  getDistributionCentersAtom,
  getDocumentTypesAtom,
  getGLCodesAtom,
  getPrioritiesAtom,
  getPurchasersAtom,
  getRetailersAtom,
  getStagesAtom,
  getValiditiesAtom,
  getPromoTypesAtom,
  getPromoStatusesAtom,
  getDisputeTrackingStatusesAtom,
  getProductsAtom,
  glCodesAtom,
  prioritiesAtom,
  purchasersAtom,
  retailersAtom,
  stagesAtom,
  validitiesAtom,
  promoTypesAtom,
  promoStatusesAtom,
  disputeTrackingStatusesAtom,
  productsAtom,
} from "@/store/lookup";

export function useLookup() {
  // Getters
  const adjustmentTypesLookup = useAtomValue(adjustmentTypesAtom);
  const accountingSystemsLookup = useAtomValue(accountingSystemsAtom);
  const adjustmentCategoriesLookup = useAtomValue(adjustmentCategoriesAtom);
  const deductionTypeCategoriesLookup = useAtomValue(deductionTypeCategoriesAtom);
  const brandMembersLookup = useAtomValue(brandMembersAtom);
  const deductionTypesLookup = useAtomValue(deductionTypesAtom);
  const distributionCentersLookup = useAtomValue(distributionCentersAtom);
  const documentTypesLookup = useAtomValue(documentTypesAtom);
  const glCodesLookup = useAtomValue(glCodesAtom);
  const prioritiesLookup = useAtomValue(prioritiesAtom);
  const purchasersLookup = useAtomValue(purchasersAtom);
  const retailersLookup = useAtomValue(retailersAtom);
  const stagesLookup = useAtomValue(stagesAtom);
  const validitiesLookup = useAtomValue(validitiesAtom);
  const documentSubTypesLookup = useAtomValue(documentSubTypesAtom);
  const promoTypesLookup = useAtomValue(promoTypesAtom);
  const promoStatusesLookup = useAtomValue(promoStatusesAtom);
  const disputeTrackingStatusesLookup = useAtomValue(disputeTrackingStatusesAtom);
  const productsLookup = useAtomValue(productsAtom);

  // Actions
  const getAdjustmentTypesLookup = useSetAtom(getAdjustmentTypesAtom);
  const getAccountingSystemsLookup = useSetAtom(getAccountingSystemsAtom);
  const getAdjustmentCategoriesLookup = useSetAtom(getAdjustmentCategoriesAtom);
  const getDeductionTypeCategoriesLookup = useSetAtom(getDeductionTypeCategoriesAtom);
  const getBrandMembersLookup = useSetAtom(getBrandMembersAtom);
  const getDeductionTypesLookup = useSetAtom(getDeductionTypesAtom);
  const getDistributionCentersLookup = useSetAtom(getDistributionCentersAtom);
  const getDocumentTypesLookup = useSetAtom(getDocumentTypesAtom);
  const getDocumentSubTypesLookup = useSetAtom(getDocumentSubTypesAtom);
  const getGLCodesLookup = useSetAtom(getGLCodesAtom);
  const getPrioritiesLookup = useSetAtom(getPrioritiesAtom);
  const getPurchasersLookup = useSetAtom(getPurchasersAtom);
  const getRetailersLookup = useSetAtom(getRetailersAtom);
  const getStagesLookup = useSetAtom(getStagesAtom);
  const getValiditiesLookup = useSetAtom(getValiditiesAtom);
  const getPromoTypesLookup = useSetAtom(getPromoTypesAtom);
  const getPromoStatusesLookup = useSetAtom(getPromoStatusesAtom);
  const getDisputeTrackingStatusesLookup = useSetAtom(getDisputeTrackingStatusesAtom);
  const getProductsLookup = useSetAtom(getProductsAtom);

  return {
    adjustmentTypesLookup,
    accountingSystemsLookup,
    adjustmentCategoriesLookup,
    deductionTypeCategoriesLookup,
    brandMembersLookup,
    deductionTypesLookup,
    distributionCentersLookup,
    documentTypesLookup,
    documentSubTypesLookup,
    glCodesLookup,
    prioritiesLookup,
    purchasersLookup,
    retailersLookup,
    stagesLookup,
    validitiesLookup,
    promoTypesLookup,
    promoStatusesLookup,
    disputeTrackingStatusesLookup,
    productsLookup,
    getAdjustmentTypesLookup,
    getAccountingSystemsLookup,
    getAdjustmentCategoriesLookup,
    getDeductionTypeCategoriesLookup,
    getBrandMembersLookup,
    getDeductionTypesLookup,
    getDistributionCentersLookup,
    getDocumentTypesLookup,
    getDocumentSubTypesLookup,
    getGLCodesLookup,
    getPrioritiesLookup,
    getPurchasersLookup,
    getRetailersLookup,
    getStagesLookup,
    getValiditiesLookup,
    getPromoTypesLookup,
    getPromoStatusesLookup,
    getDisputeTrackingStatusesLookup,
    getProductsLookup,
  };
}
